import { EventService as t } from "@nextgen-web-framework/core";
import { ProfileEventsVersionsEnum as o } from "../types/enums/profileEventsVersionsEnum.js";
const n = (e) => `profile.domain.${e}`, i = () => /* @__PURE__ */ new Date(), c = () => "purchase.sample", u = () => o["1.0.0"], m = (e) => ({
  timestamp: i(),
  sourceSystem: c(),
  eventName: e,
  version: u()
}), E = {
  publishEvent({ event: e }) {
    const s = {
      metadata: m(e)
    };
    t.publish(n(e), s);
  },
  subscribeEvents({ topics: e, version: s, cb: a }) {
    (Array.isArray(e) ? e : Array.of(e)).forEach((r) => {
      t.unsubscribe(r), t.subscribe(n(r), s, a);
    });
  },
  unsubscribe(e) {
    t.unsubscribeMultiple(e);
  }
};
export {
  E as ProfileEvents,
  E as default
};
//# sourceMappingURL=profileEventsUtil.js.map
